module.exports = __webpack_public_path__ + "static/media/class2.4870d805.jpg";